import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { RegexpType, validator } from 'utils/validator';

import { ActionButton, IconAccept, IconDecline } from '../CustomRadio/style';
import { Input, InputContainer } from './style';

const CustomInput = ({
  onBlur,
  onChange,
  placeholder,
  value,
  name,
  icon,
  type,
  valid,
  readonly,
  autoFocus,
  disabled,
  isEditable,
  onFocus,
  onKeyPress,
  defaultValue,
  onKeyUp,
  padding,
  onClose,
  onAccept,
  isLeadDetail,
  status
}) => {
  const [val, setVal] = useState(value);
  useEffect(() => {
    setVal(value);
  }, [value]);

  const updateValue = ({ currentTarget: { value: newValue } = {} }) => {
    if (newValue.length <= 0 || !validator(RegexpType.SPACEONLY, newValue)) {
      setVal(newValue);
      if (onChange) onChange(newValue.trim());
    }
  };

  const handleOnBlur = () => {
    setVal(val || defaultValue);
    if (onBlur) onBlur(val || defaultValue);
  };

  /*const handleOnFocus = () => {
    if (onFocus) onFocus();
  };
*/
  const handleOnKeyPress = e => {
    if (onKeyPress) onKeyPress(e);
  };
  const handleOnKeyUp = e => {
    if (onKeyUp) onKeyUp(e);
  };

  const handleOnclickDecline = () => {
    setVal(value);
    if (onClose) {
      onClose();
    }
  };
  const handleOnclickAccept = () => {
    if (onAccept) {
      onAccept();
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <InputContainer
      valid={readonly || (valid && typeof valid !== 'string')}
      // status={status}
      value={value}
      readonly={readonly}
      disabled={disabled}
      padding={padding}
    >
      <Input
        // onFocus={handleOnFocus}
        autoFocus={autoFocus}
        type={type}
        onBlur={handleOnBlur}
        onChange={updateValue}
        onKeyPress={handleOnKeyPress}
        onKeyUp={handleOnKeyUp}
        placeholder={readonly ? '' : placeholder}
        value={val}
        name={name}
        readonly={readonly}
        disabled={disabled}
        icon={icon}
        isEditable={isEditable}
        isLeadDetail={isLeadDetail}
      />
      {isEditable && !isLeadDetail && (
        <ActionButton>
          <IconDecline
            className="icon-close"
            hasValue={val?.length >= 1}
            onClick={handleOnclickDecline}
          />
          <IconAccept
            className="icon-checkok"
            hasValue={val?.length >= 1}
            onClick={handleOnclickAccept}
          />
        </ActionButton>
      )}
    </InputContainer>
  );
};

CustomInput.propTypes = {
  onChange: PropTypes.func,
  onAccept: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyUp: PropTypes.func,
  onClose: PropTypes.func,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  valid: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  isEditable: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.string,
  isLeadDetail: PropTypes.bool
};

CustomInput.defaultProps = {
  autoFocus: false,
  placeholder: '',
  readonly: false,
  type: 'text',
  valid: true
};

export default CustomInput;
